import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotProducts from './components/HotProducts';
import BrandAdvantages from './components/BrandAdvantages';
import FeaturedArticles from './components/FeaturedArticles';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const seoTitle = '蜜芽官方落地页｜母婴精选好物一站购齐';
  const seoDesc = '蜜芽是中国领先的母婴跨境电商平台，汇聚全球优质母婴品牌，涵盖奶粉、纸尿裤、玩具、童装等海量品类。蜜芽致力于为中国家庭提供安全、正品、高性价比的母婴商品。';
  const seoKeywords = '蜜芽,蜜芽母婴,蜜芽跨境购,蜜芽正品奶粉,蜜芽海外母婴,蜜芽优惠活动,母婴跨境电商平台';
  const canonicalUrl = 'https://childcart.github.io';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '蜜芽母婴跨境电商平台',
        url: canonicalUrl,
        description: seoDesc,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-6688',
          contactType: 'customer service',
          availableLanguage: 'Chinese',
        },
      },
      {
        '@type': 'WebSite',
        name: '蜜芽',
        url: canonicalUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${canonicalUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: seoTitle,
        description: seoDesc,
        url: canonicalUrl,
        isPartOf: { '@type': 'WebSite', name: '蜜芽', url: canonicalUrl },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalUrl={canonicalUrl}
        ogType="website"
        ogImage="https://readdy.ai/api/search-image?query=Warm%20soft%20minimalist%20nursery%20interior%20with%20gentle%20morning%20sunlight%2C%20cream%20and%20beige%20palette%20motherhood%20branding&width=1200&height=630&seq=og-home-mia&orientation=landscape"
        schema={schema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotProducts />
        <BrandAdvantages />
        <FeaturedArticles />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}